import { axiosPrivate } from 'modules/networkTools/networkTools';
import { useEffect, useState } from 'react';

export const useFetchAvatarImage = (profileImageKey: string | undefined) => {
  const [avatarImage, setAvatarImage] = useState<string>();

  useEffect(() => {
    const fetchAvatarImage = async () => {
      if (profileImageKey) {
        const url = `setup/organization/user/profile-image?key=${profileImageKey}`;
        const response = await axiosPrivate.get(url, { responseType: 'blob' });
        setAvatarImage(URL.createObjectURL(new Blob([response.data])));
      }
    };

    fetchAvatarImage();
  }, [profileImageKey]);

  return avatarImage;
};
